import { inputs } from '@ecosystem/newron-design-system';

export const WithWeekRangePicker = ({ defaultDates, onChange, ...otherProps }) => {
  const { WeekPicker, WeekFormatType } = inputs;

  return (
    <div data-testid="with-week-range-picker">
      <WeekPicker
        isRange={true}
        defaultDates={defaultDates}
        onChange={onChange}
        dateFormat={WeekFormatType['Ww yyyy']}
        primaryPlaceholder="Week Year"
        secondaryPlaceholder="Week Year"
        {...otherProps}
      />
    </div>
  );
};
